import { StorageKey } from "@/util";
import { createSlice } from "@reduxjs/toolkit";
import { Iuser as userType } from "@/util/types";
import AppStorage from "@/util/services/storage";

const initialState:Partial<userType> = AppStorage.getItem(StorageKey.User) ?? {};


export const user=createSlice({
    name:'user',
    initialState,
    reducers:{
        ADD_USER:(state,action)=>{
           AppStorage.saveItem(StorageKey.User,action.payload.data);
        AppStorage.saveItem(StorageKey.UserToken,action.payload.accessToken)
      return {...state,...action.payload.data};
     },
     UPDATE_USER:(state,action)=>{
        AppStorage.saveItem(StorageKey.User,action.payload);
      return {...state,...action.payload}
     },
     REMOVE_USER:()=>{
        AppStorage.deleteItem(StorageKey.User);
        AppStorage.deleteItem(StorageKey.UserToken);
     return {}
     
     }
     
    }
})

export const{ADD_USER,REMOVE_USER,UPDATE_USER}=user.actions;
export default user.reducer;